import {
  Component,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { BookingStore } from '@store';
import { SubscriptionPlan } from '@vi-iot/client';
import { matTooltipSetter } from '../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
@Component({
  selector: 'app-booking-plans-voucher',
  templateUrl: './booking-plans-voucher.component.html',
  styleUrls: ['./booking-plans-voucher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingPlansVoucherComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  @Output() planSelected = new EventEmitter();
  @Output() nextStep = new EventEmitter();
  @Output() trialPlanSelected = new EventEmitter();

  BookingPlans = SubscriptionPlan;

  constructor(public bookingStore: BookingStore) {}

  enterCode(): void {
    this.bookingStore.selectPlan(SubscriptionPlan.Pro);
    this.nextStep.emit();
    this.planSelected.emit();
  }

  testTrial(): void {
    this.bookingStore.selectPlan(SubscriptionPlan.Trial);
    this.nextStep.emit();
    this.planSelected.emit();
  }
}
